import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import swal from 'sweetalert2';
import User from '_class/User';
import DateTime from '_class/DateTime';
import { addComment, updateStudentAdjustment, deleteStudentAdjustment } from 'actions/additional_adjustments';
import Modal from 'containers/Modals/Modal';
import { Collapsible, Spinner } from 'UI';
import { Block, Flex, Select, Icon, Button, translate } from '@haldor/ui';
import PostContent from 'components/Presentation/PostContent';
import EditAdditionalAdjustmentSubjects from '../Form/EditAdditionalAdjustmentSubjects';
import EditStudentAdjustmentForm from '../Form/EditStudentAdjustmentForm';
import Comments from './Partials/Comments';
import './Adjustment.scss';

var StudentAdjustment = /*#__PURE__*/function (_Component) {
  _inherits(StudentAdjustment, _Component);

  var _super = _createSuper(StudentAdjustment);

  function StudentAdjustment(props) {
    var _this;

    _classCallCheck(this, StudentAdjustment);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "addComment", function (values) {
      var adjustment = _this.props.adjustment;
      return new Promise(function (resolve) {
        _this.props.addComment(values, adjustment.id).then(function () {
          resolve(1);
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onStatusChange", /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(status) {
        var values;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.setState({
                  status: status,
                  loading: true
                });

                values = _objectSpread({}, _this.props.adjustment);
                values.status = status;

                if (status == 'COMPLETED') {
                  values.endDate = moment().format('YYYY-MM-DD');
                } else {
                  values.endDate = null;
                }

                _context.next = 6;
                return _this.props.updateStudentAdjustment(values);

              case 6:
                _this.setState({
                  loading: false
                });

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "onAdjustmentSubmit", function (values) {
      return new Promise(function (resolve) {
        _this.setState({
          loading: true
        });

        _this.props.updateStudentAdjustment(values).then(function () {
          _this.setState({
            loading: false,
            editAdjustment: false
          });

          resolve(1);
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onAdjustmentRemove", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var translate, user, response;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              translate = _this.props.translate;
              user = new User(_this.props.user);

              _this.setState({
                loading: true
              });

              if (user.isPedagogue()) {
                _context2.next = 10;
                break;
              }

              _context2.next = 6;
              return swal.fire({
                title: translate('Are you sure?'),
                text: translate('The adjustment will be removed from the student wherever it is used. Restoration can only be done by a special educational needs teacher.'),
                showCancelButton: true,
                cancelButtonText: translate('Cancel'),
                confirmButtonText: translate('Remove')
              });

            case 6:
              response = _context2.sent;

              if (!(response.value == null)) {
                _context2.next = 10;
                break;
              }

              _this.setState({
                loading: false
              });

              return _context2.abrupt("return", false);

            case 10:
              _context2.next = 12;
              return _this.props.deleteStudentAdjustment(_this.props.adjustment);

            case 12:
              _this.setState({
                loading: false
              });

            case 13:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    })));

    _defineProperty(_assertThisInitialized(_this), "toggleCourseModal", function () {
      _this.setState({
        courseModal: !_this.state.courseModal
      });
    });

    _defineProperty(_assertThisInitialized(_this), "toggleEditModal", function () {
      _this.setState({
        editAdjustment: !_this.state.editAdjustment
      });
    });

    _this.state = {
      status: props.adjustment.status,
      courseModal: false,
      editAdjustment: false,
      loading: false
    };
    return _this;
  }
  /* Event methods - JEVEN */


  _createClass(StudentAdjustment, [{
    key: "render",
    value:
    /* Render methods - JREND */
    function render() {
      var _statuses$find,
          _this2 = this;

      var _this$props = this.props,
          adjustment = _this$props.adjustment,
          translate = _this$props.translate;

      if (adjustment == null) {
        return null;
      }

      var user = new User(this.props.user);
      var statuses = [{
        label: translate('Active'),
        value: 'ACTIVE'
      }, {
        label: translate('adjustment-closed'),
        value: 'COMPLETED'
      }];
      var status = (_statuses$find = statuses.find(function (st) {
        return st.value == _this2.state.status;
      })) !== null && _statuses$find !== void 0 ? _statuses$find : null;
      var student = new User(this.props.adjustment.student);
      var collapseTrigger = /*#__PURE__*/React.createElement("strong", {
        className: "trigger",
        style: {
          cursor: 'pointer'
        }
      }, /*#__PURE__*/React.createElement("span", {
        style: {
          whiteSpace: 'nowrap'
        }
      }, this.props.translate('subjects'), " ", adjustment.subjects.length), !user.isStudent() ? /*#__PURE__*/React.createElement("span", {
        onClick: function onClick(e) {
          e.preventDefault();
          e.stopPropagation();

          _this2.toggleCourseModal();
        }
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "Pen_Small"
      })) : null);
      return /*#__PURE__*/React.createElement("div", {
        className: "adjustment"
      }, /*#__PURE__*/React.createElement(Modal, {
        isOpen: this.state.courseModal,
        onClose: this.toggleCourseModal,
        type: "small",
        title: translate('Subjects')
      }, /*#__PURE__*/React.createElement(EditAdditionalAdjustmentSubjects, {
        adjustment: adjustment,
        onClose: this.toggleCourseModal
      })), /*#__PURE__*/React.createElement(Modal, {
        isOpen: this.state.editAdjustment,
        onClose: this.toggleEditModal,
        title: translate('edit-adjustment-for') + ' ' + student.getName()
      }, /*#__PURE__*/React.createElement(EditStudentAdjustmentForm, {
        adjustment: adjustment,
        onClose: this.toggleEditModal,
        onSubmit: this.onAdjustmentSubmit
      })), /*#__PURE__*/React.createElement(Block, null, /*#__PURE__*/React.createElement("span", {
        className: "title"
      }, adjustment.additionalAdjustment.subTitle != null ? adjustment.additionalAdjustment.title + ' ' + adjustment.additionalAdjustment.subTitle : adjustment.additionalAdjustment.title), /*#__PURE__*/React.createElement(Flex, null, /*#__PURE__*/React.createElement("div", {
        style: {
          width: '100%'
        }
      }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(PostContent, null, adjustment.description), /*#__PURE__*/React.createElement("div", {
        className: "createdBy color--meta"
      }, adjustment.createdBy.firstName, " ", adjustment.createdBy.lastName, ' • ' + new DateTime(adjustment.created).getShortDate(true))), !user.isStudent() ? /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: '1rem'
        }
      }, /*#__PURE__*/React.createElement(Comments, {
        form: 'comment-' + adjustment.id,
        adjustment: adjustment,
        onSubmit: this.addComment
      })) : null), /*#__PURE__*/React.createElement("div", {
        className: "adjustment-meta size-14"
      }, this.state.status == 'ACTIVE' ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("strong", null, this.props.translate('start-time')), /*#__PURE__*/React.createElement("br", null), new DateTime(adjustment.startDate).getShortDate()) : /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("strong", null, this.props.translate('time-period')), /*#__PURE__*/React.createElement("br", null), new DateTime(adjustment.startDate).getShortDate(), ' - ' + new DateTime(adjustment.endDate).getShortDate()), this.state.status != 'DELETED' ? /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: '1rem'
        }
      }, /*#__PURE__*/React.createElement("strong", null, this.props.translate('Status')), /*#__PURE__*/React.createElement("br", null), !user.isStudent() ? /*#__PURE__*/React.createElement(Select, {
        onChange: this.onStatusChange,
        options: statuses
      }, status === null || status === void 0 ? void 0 : status.label) : status === null || status === void 0 ? void 0 : status.label) : null, /*#__PURE__*/React.createElement("div", {
        className: "meta-courses",
        style: {
          marginTop: '1rem'
        }
      }, /*#__PURE__*/React.createElement(Collapsible, {
        trigger: collapseTrigger
      }, adjustment.subjects != null ? adjustment.subjects.map(function (subject) {
        return /*#__PURE__*/React.createElement("div", {
          key: subject.id
        }, subject.title);
      }) : null), /*#__PURE__*/React.createElement("br", null), !user.isStudent() && adjustment.status == 'ACTIVE' ? /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: 5
        }
      }, /*#__PURE__*/React.createElement(Button, {
        type: "secondary",
        onClick: this.toggleEditModal,
        disabled: this.state.loading
      }, this.state.loading ? /*#__PURE__*/React.createElement(Spinner, {
        center: true
      }) : null, /*#__PURE__*/React.createElement(Icon, {
        name: "Pen_Small"
      }), this.props.translate('Edit'))) : null, !user.isStudent() && adjustment.status == 'COMPLETED' ? /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: 5
        }
      }, /*#__PURE__*/React.createElement(Button, {
        type: "secondary",
        onClick: this.onAdjustmentRemove,
        disabled: this.state.loading
      }, this.state.loading ? /*#__PURE__*/React.createElement(Spinner, {
        center: true
      }) : null, /*#__PURE__*/React.createElement(Icon, {
        name: "Bin"
      }), this.props.translate('Remove'))) : null, !user.isStudent() && user.isPedagogue() && adjustment.status == 'DELETED' ? /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: 5
        }
      }, /*#__PURE__*/React.createElement(Button, {
        type: "secondary",
        onClick: function onClick() {
          return _this2.onStatusChange('COMPLETED');
        },
        disabled: this.state.loading
      }, this.state.loading ? /*#__PURE__*/React.createElement(Spinner, {
        center: true
      }) : null, /*#__PURE__*/React.createElement(Icon, {
        name: "Undo"
      }), this.props.translate('reset'))) : null, !user.isStudent() && user.isPedagogue() && adjustment.status == 'DELETED' ? /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: 5
        }
      }, /*#__PURE__*/React.createElement(Button, {
        type: "secondary",
        onClick: this.onAdjustmentRemove,
        disabled: this.state.loading
      }, this.state.loading ? /*#__PURE__*/React.createElement(Spinner, {
        center: true
      }) : null, /*#__PURE__*/React.createElement(Icon, {
        name: "Bin"
      }), this.props.translate('Remove permanently'))) : null)))));
    }
  }]);

  return StudentAdjustment;
}(Component);

function mapStateToProps(state) {
  return {
    translate: translate(state.Languages.translations),
    user: state.user.currentUser
  };
}

export default connect(mapStateToProps, {
  addComment: addComment,
  updateStudentAdjustment: updateStudentAdjustment,
  deleteStudentAdjustment: deleteStudentAdjustment
})(StudentAdjustment);